import React from "react";
import Tooltip from "@atlaskit/tooltip";
import AddCircleIcon from "@atlaskit/icon/glyph/add-circle";
import { IconContainer } from "./styled";
import { useTheme } from "styled-components";
import { useTranslation } from "react-i18next";
import { DeleteIcon } from "./icons/Actions";

function Actions({
  node,
  userInfo,
  hasChildren,
  handleAddUsers,
  handleDeleteUser,
}) {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <>
      <Tooltip content="Add new" position="bottom">
        <IconContainer
          position="bottom"
          isCentered={!hasChildren}
          onClick={(e) =>
            handleAddUsers(e, { id: node.id, name: userInfo?.name })
          }
        >
          <AddCircleIcon
            primaryColor={theme.orgchart.minusPlusColor}
            secondaryColor="#97A0AF"
          />
        </IconContainer>
      </Tooltip>

      <Tooltip content="Remove" position="bottom">
        <IconContainer
          theme={theme}
          position="right"
          onClick={(e) => handleDeleteUser(userInfo?.key)}
        >
          <DeleteIcon />
        </IconContainer>
      </Tooltip>
    </>
  );
}

export default Actions;
